import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppVersionConfigService } from '../config';


@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {
    constructor(@Inject(AppVersionConfigService) private appVersion: string) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request to add the new header
        req = req.clone({
            headers: req.headers.set('app_version', this.appVersion)
        });

        // Pass the cloned request instead of the original request to the next handle
        return next.handle(req);
    }
}
